import { useState, useCallback } from 'react';
import { GridSortModel } from '@mui/x-data-grid';

export const useTableSort = () => {
  const [sortModel, setSortModel] = useState<GridSortModel>([]);

  const handleSortModelChange = useCallback((newModel: GridSortModel) => {
    setSortModel(newModel);
  }, []);

  return {
    sortModel,
    handleSortModelChange
  };
};